export interface ArticleFull {
  id: number;
  slug: string;
  title: string;
  excerpt: string;
  tag: string;
  category: string;
  categorySlug: string;
  date: string;
  views: number;
  imageUrl: string;
  author: string;
  authorAvatar: string;
  content: string[];
  tags: string[];
}

export const articleDetails: Record<number, ArticleFull> = {
  1: {
    id: 1,
    slug: 'top-influencer-live-fail',
    title: '顶流网红直播翻车现场：千万粉丝博主人设崩塌全记录',
    excerpt: '近日，某拥有千万粉丝的顶流网红在直播中意外翻车，一系列不当言论和行为引发全网热议。事件发生后，该网红的粉丝数在一小时内暴跌超过50万。',
    tag: '独家爆料',
    category: '网红黑料',
    categorySlug: 'wanghong-heiliao',
    date: '2026-07-06',
    views: 1280000,
    imageUrl: 'https://readdy.ai/api/search-image?query=Dramatic%20studio%20lighting%20scene%20with%20shadowy%20abstract%20figure%20silhouette%20against%20dark%20emerald%20background%2C%20moody%20atmosphere%2C%20editorial%20magazine%20photography%20style%2C%20mysterious%20and%20intriguing%20composition%2C%20soft%20rim%20lighting%20creating%20tension%2C%20cinematic%20color%20grading%20with%20deep%20greens%20and%20blacks%2C%20artistic%20blur%20effects%2C%20empty%20space%20for%20text%20overlay&width=1200&height=675&seq=article-detail-01&orientation=landscape',
    author: '吃瓜前线记者',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Minimalist%20abstract%20avatar%20in%20warm%20beige%20tones%2C%20simple%20geometric%20circular%20design%2C%20soft%20gradient%20background%2C%20modern%20flat%20illustration%20style%2C%20professional%20yet%20friendly%20aesthetic%2C%20clean%20lines%20and%20subtle%20texture&width=80&height=80&seq=author-avatar-01&orientation=squarish',
    tags: ['网红翻车', '直播事故', '人设崩塌', '百万掉粉'],
    content: [
      '6月30日晚间，某拥有超过1200万粉丝的顶流网红在例行直播中突然情绪失控，对一名观众破口大骂，随后更是爆出了多个惊人的内幕消息，让整个直播间瞬间炸开了锅。',
      '据现场观众描述，当晚该网红的直播状态就有些不对劲，开场时精神恍惚，在回答粉丝提问时前言不搭后语。直播约半小时后，一条弹幕彻底点燃了导火索——"你那些数据都是刷的吧，别装了"。',
      '该网红看到后先是冷笑一声，随后开始了一段长达15分钟的失控发言。"你懂什么？你们根本不懂我是怎么走到今天的！那些品牌方、MCN机构，全都是骗子！"他情绪激动地拍打着桌子，甚至连旁边价值不菲的显示器都被震得晃动起来。',
      '更令人震惊的是，他在直播中还透露了自己与多家品牌的合作内幕。"我代言的那个护肤品，我自己从来不用，用一次烂脸三天！但合同签了，我只能昧着良心说好用。"这番话一出，直播间弹幕瞬间爆炸，不少粉丝表示三观尽毁。',
      '事件发生后不到30分钟，与该网红合作的多个品牌方迅速发布声明，表示已终止合作关系。某知名护肤品牌甚至火速下架了所有与该网红相关的宣传物料，其社交媒体账号也删除了所有合作内容。',
      '业内人士分析认为，这次事件对该网红的影响将是毁灭性的。一位不愿透露姓名的MCN机构负责人表示："在现在的环境下，品牌方最看重的就是合作对象的口碑和稳定性。这种行为不仅会毁掉他自己的职业生涯，连带着整个团队都会受到牵连。"',
      '截至发稿前，该网红的所有社交账号均已设为私密状态，其经纪团队也未对此事做出任何正式回应。不过有消息称，该网红目前正考虑退出网络圈，转型做幕后工作。',
      '此事也给整个直播行业敲响了警钟。有专家指出，网红经济的野蛮生长已经带来了诸多问题，行业亟需建立更完善的规范和监管机制。对于广大粉丝来说，也许也是时候重新审视"追星"这件事了。',
    ],
  },
  2: {
    id: 2,
    slug: 'chat-records-leak',
    title: '某知名博主私密聊天记录外泄，内容劲爆引全网热议',
    excerpt: '一份疑似某知名博主与多人的私密聊天记录在网络上疯传，内容涉及多段隐秘关系的细节，引发网友对网络隐私安全的广泛讨论。',
    tag: '聊天记录',
    category: '聊天记录',
    categorySlug: 'liaotian-jilu',
    date: '2026-07-05',
    views: 965000,
    imageUrl: 'https://readdy.ai/api/search-image?query=Close-up%20abstract%20composition%20of%20fragmented%20text%20messages%20on%20dark%20surface%2C%20warm%20amber%20and%20sage%20green%20color%20palette%2C%20mysterious%20digital%20communication%20theme%2C%20soft%20focus%20artistic%20photography%2C%20glowing%20screen%20reflections%2C%20intimate%20and%20secretive%20atmosphere%2C%20editorial%20style%20with%20shallow%20depth%20of%20field%2C%20high-end%20magazine%20aesthetic&width=1200&height=675&seq=article-detail-02&orientation=landscape',
    author: '深度调查员',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Abstract%20geometric%20avatar%20with%20muted%20sage%20green%20palette%2C%20minimalist%20circular%20design%2C%20soft%20modern%20illustration%20style%2C%20subtle%20gradient%20tones%2C%20clean%20and%20sophisticated%20aesthetic%2C%20professional%20friendly%20feel&width=80&height=80&seq=author-avatar-02&orientation=squarish',
    tags: ['聊天记录泄露', '隐私安全', '网络暴力', '博主翻车'],
    content: [
      '7月4日凌晨，一份包含上千条对话记录的截图包在各大社交媒体平台迅速传播。据初步判断，该聊天记录来自于一位拥有500万粉丝的知名生活类博主，内容涉及她与多位圈内人士的私人对话。',
      '从泄露的内容来看，对话涉及的话题极为广泛且劲爆——包括对其他网红的私下评价、与品牌方的利益纠葛、以及一些极为私密的个人情感问题。',
      '其中一段对话尤为引人关注：该博主在聊天中直言某同行博主"完全是靠买粉买流量堆起来的"，还附带了一组所谓的"后台数据截图"。这段对话被曝光后，被点名的博主立即发声明否认，并表示将通过法律途径维权。',
      '更令人瞠目的是，聊天记录中还包含了她与多名男性友人的暧昧对话。有细心的网友通过对比时间线发现，其中一些对话发生在她公开宣称的"恋爱空窗期"期间，而对话的亲密程度远超普通朋友范畴。',
      '此事一出，立即在网络上引发了关于数字隐私的激烈讨论。网络安全专家指出，此次泄露事件很可能是因为该博主的手机被黑客入侵，或者是iCloud账号密码被破解导致的。',
      '我们是否能真正享受数字时代的隐私自由？当我们的每一句话都可能被记录、被泄露、被审判，我们还能保持多少真实？',
      '截至发稿，该博主已关闭了所有社交平台的评论功能，并发表简短的道歉声明，称"对于最近流传的私人对话内容，给相关人员带来的困扰表示歉意"。但并未对聊天记录的真实性做出明确回应。',
    ],
  },
  3: {
    id: 3,
    slug: 'contrast-blogger-exposed',
    title: '反差萌博主真实身份大曝光，甜美形象背后另有隐情',
    excerpt: '以甜美形象走红的某反差博主被网友扒出真实身份，与其在镜头前展现的人设形成了巨大反差，引发全网热议。',
    tag: '反差视频',
    category: '反差视频',
    categorySlug: 'fancha-shipin',
    date: '2026-07-04',
    views: 845000,
    imageUrl: 'https://readdy.ai/api/search-image?query=Dual-tone%20abstract%20composition%20split%20between%20soft%20pink%20and%20dark%20muted%20teal%2C%20contrasting%20textures%20and%20moods%2C%20artistic%20duality%20concept%2C%20modern%20editorial%20photography%2C%20mysterious%20and%20thought-provoking%20atmosphere%2C%20soft%20gradient%20blending%2C%20sophisticated%20color%20palette%20with%20warm%20and%20cool%20tones%2C%20magazine%20cover%20style%20with%20elegant%20negative%20space&width=1200&height=675&seq=article-detail-03&orientation=landscape',
    author: '八卦研究所',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Simple%20abstract%20circular%20avatar%20in%20warm%20terracotta%20tones%2C%20minimalist%20geometric%20design%2C%20soft%20gradient%20background%2C%20modern%20flat%20illustration%2C%20friendly%20and%20approachable%20aesthetic%2C%20clean%20smooth%20lines&width=80&height=80&seq=author-avatar-03&orientation=squarish',
    tags: ['反差博主', '人设崩塌', '真实身份', '网络人设'],
    content: [
      '在短视频平台上以"邻家甜妹"形象走红的某博主，近日被网友扒出其在现实生活中的真实身份，与其精心打造的屏幕形象形成了令人难以置信的反差。',
      '该博主在视频中总是以乖乖女、甜美可爱的形象示人，穿着JK制服、扎着双马尾，说话带点撒娇的口吻。凭借这个形象，她在短短半年内积累了超过300万粉丝，带货业绩也颇为亮眼。',
      '然而，有自称是该博主大学同学的网友曝光了一组旧照和相关信息。照片中的人与屏幕上的甜妹判若两人——短发、中性打扮、手持电吉他，看起来完全是个摇滚girl的风格。更惊人的是，她还曾是校辩论队的队长，以言辞犀利著称。',
      '"她高中时就是个‘学霸御姐’，成绩年级前十，说话做事都非常干练。第一次在抖音上刷到她的时候，我差点没认出来。"这位自称同学的网友评论道。',
      '对于这些爆料，网友的态度出现了两极分化。一部分人认为这是一种"欺骗"，利用虚假人设来骗取粉丝的喜爱和信任；另一部分人则表示理解："网红本质上就是一份工作，打造人设是职业需要，她只是演了一个角色而已。"',
      '该博主最终在直播中坦然回应，承认了自己过去的真实形象，并表示："我从来没有刻意欺骗大家，只是想在网络上展现不一样的自己。每个人都有多面性，甜美和酷都是我。"这番回应让不少粉丝表示更加喜欢她了。',
      '这场风波也让人们开始思考：在互联网时代，我们追逐的到底是一个真实的人，还是自己想象中的完美形象？是包装，还是欺骗？也许，界限并没有我们想象的那么清晰。',
    ],
  },
  4: {
    id: 4,
    slug: 'celebrity-marriage-crisis',
    title: '明星夫妻婚姻危机升级，男方夜会神秘女子被拍',
    excerpt: '娱乐圈又一对模范夫妻面临婚姻危机，男方深夜与神秘女子约会的照片被媒体曝光，引发粉丝高度关注。',
    tag: '独家爆料',
    category: '明星爆料',
    categorySlug: 'mingxing-baoliao',
    date: '2026-07-04',
    views: 1560000,
    imageUrl: 'https://readdy.ai/api/search-image?query=Moody%20nighttime%20abstract%20scene%20with%20warm%20amber%20street%20light%20reflections%2C%20blurred%20figures%20in%20the%20distance%2C%20cinematic%20noir%20atmosphere%2C%20dark%20emerald%20and%20golden%20tones%2C%20mysterious%20urban%20night%20photography%20style%2C%20soft%20focus%20artistic%20composition%2C%20elegant%20editorial%20aesthetic%20with%20dramatic%20shadows&width=1200&height=675&seq=article-detail-04&orientation=landscape',
    author: '吃瓜前线记者',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Minimalist%20circular%20avatar%20design%20with%20soft%20taupe%20and%20cream%20palette%2C%20abstract%20geometric%20style%2C%20subtle%20gradient%20background%2C%20modern%20flat%20illustration%2C%20professional%20clean%20aesthetic%2C%20gentle%20warm%20tones&width=80&height=80&seq=author-avatar-04&orientation=squarish',
    tags: ['明星夫妻', '婚姻危机', '出轨疑云', '娱乐圈'],
    content: [
      '7月3日晚，某知名娱乐媒体独家拍到一对被公认为娱乐圈"最恩爱夫妻"的男方深夜与一名神秘女子单独约会的画面。照片中两人举止亲密，男方还用手臂环抱了女子的肩膀。',
      '这对夫妻结婚已有8年，育有两个孩子，一直以来都给人恩爱有加的印象。男方更是多次在公开场合表示"妻子是自己一生的挚爱"，两人的社交账号上也经常互相表白。',
      '然而，这次被拍到的画面给这个"完美婚姻"的故事蒙上了一层阴影。据拍摄者称，当晚11点左右，男方独自驾车来到位于城东的一家高档餐厅，随后一名年轻女性进入餐厅与其会面。两人在餐厅内待了近两小时，出来时男方还体贴地为女子打开了车门。',
      '更耐人寻味的是，在照片被曝光的当天，女方恰好发了一条意味深长的微博："有些真相，知道得越晚越好。"这条微博虽然很快被删除，但已经被众多网友截图保存。',
      '目前两人的经纪公司均未对此事做出回应。但有内部人士透露，两人的婚姻确实出现了问题，这次事件可能只是一个导火索。该人士称，由于工作性质的缘故，两人长期聚少离多，感情早已出现裂痕。',
    ],
  },
  5: {
    id: 5,
    slug: 'influencer-tax-evasion',
    title: '知名带货网红涉嫌偷税漏税，直播间已紧急停播',
    excerpt: '继多位头部主播被查后，又一位知名带货网红因涉嫌税务问题被立案调查，其所有直播活动目前均已暂停。',
    tag: '重磅消息',
    category: '网红黑料',
    categorySlug: 'wanghong-heiliao',
    date: '2026-07-03',
    views: 2340000,
    imageUrl: 'https://readdy.ai/api/search-image?query=Abstract%20composition%20with%20harsh%20fluorescent%20lighting%2C%20empty%20studio%20atmosphere%2C%20abandoned%20broadcast%20equipment%20silhouettes%2C%20stark%20contrast%20between%20light%20and%20dark%2C%20cold%20institutional%20aesthetic%2C%20modern%20editorial%20style%20with%20dramatic%20negative%20space%2C%20muted%20teal%20and%20grey%20tones%20with%20subtle%20warm%20accents&width=1200&height=675&seq=article-detail-05&orientation=landscape',
    author: '深度调查员',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Abstract%20circular%20avatar%20in%20muted%20olive%20green%20tones%2C%20simple%20geometric%20design%2C%20soft%20gradient%20background%2C%20modern%20minimalist%20illustration%2C%20friendly%20warm%20aesthetic%2C%20clean%20lines&width=80&height=80&seq=author-avatar-05&orientation=squarish',
    tags: ['偷税漏税', '带货主播', '税务调查', '直播停播'],
    content: [
      '税务风波再度冲击直播带货圈。据权威消息源透露，某位年销售额超过10亿的知名带货网红已被税务机关正式立案调查，涉嫌通过多种手段进行偷逃税款。',
      '这位主播在业内以"带货女王"著称，单场直播GMV经常突破亿元大关。她与多个一线品牌保持深度合作，巅峰时期一年的个人收入据称高达数亿元。',
      '据知情人士透露，税务机关在对其进行税务稽查时发现，该主播通过设立多家工作室和空壳公司的方式，将个人直播收入转化为企业收入，以此规避高额的个人所得税。同时，她还存在通过"阴阳合同"低报实际收入的情况。',
      '消息传出后，她的直播间立即陷入了"停摆"状态。原本排期满满的直播日程全部被取消，多个品牌方也纷纷表示将暂停合作，等待调查结果。',
      '这并非个案。近年来，随着直播带货行业的爆发式增长，税务合规问题日益突出。相关部门已多次表态，将持续加大对网络直播从业人员的税收监管力度。',
    ],
  },
};

export interface CommentItem {
  id: number;
  author: string;
  avatar: string;
  content: string;
  date: string;
  likes: number;
}

export const articleComments: Record<number, CommentItem[]> = {
  1: [
    {
      id: 101,
      author: '吃瓜小能手',
      avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20abstract%20avatar%20in%20warm%20beige%20tones%2C%20simple%20geometric%20circular%20design%2C%20soft%20gradient%20background%2C%20modern%20flat%20illustration%20style%2C%20professional%20yet%20friendly%20aesthetic%2C%20clean%20lines%20and%20subtle%20texture&width=80&height=80&seq=comment-avatar-01&orientation=squarish',
      content: '我的天！看他直播那么多年了，没想到私下是这样的……真的好失望。那些品牌方的反应也太快了，30分钟就解约，看来早有准备啊。',
      date: '2026-07-06 22:35',
      likes: 12580,
    },
    {
      id: 102,
      author: '八卦研究员',
      avatar: 'https://readdy.ai/api/search-image?query=Abstract%20geometric%20avatar%20with%20muted%20sage%20green%20palette%2C%20minimalist%20circular%20design%2C%20soft%20modern%20illustration%20style%2C%20subtle%20gradient%20tones%2C%20clean%20and%20sophisticated%20aesthetic%2C%20professional%20friendly%20feel&width=80&height=80&seq=comment-avatar-02&orientation=squarish',
      content: '说实话，在那个环境里被捧得那么高，很容易迷失自己。但话说回来，赚了粉丝的钱就要对得起粉丝的信任，这是最基本的职业道德。',
      date: '2026-07-06 23:12',
      likes: 8920,
    },
    {
      id: 103,
      author: '熬夜冠军',
      avatar: 'https://readdy.ai/api/search-image?query=Simple%20abstract%20circular%20avatar%20in%20warm%20terracotta%20tones%2C%20minimalist%20geometric%20design%2C%20soft%20gradient%20background%2C%20modern%20flat%20illustration%2C%20friendly%20and%20approachable%20aesthetic%2C%20clean%20smooth%20lines&width=80&height=80&seq=comment-avatar-03&orientation=squarish',
      content: '最惨的是那些粉丝，真心实意支持了那么久，结果发现偶像根本不尊重他们。那个护肤品的料太猛了，以后都不敢信任何人推荐的东西了。',
      date: '2026-07-07 01:05',
      likes: 15670,
    },
    {
      id: 104,
      author: '娱乐圈观察家',
      avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20circular%20avatar%20design%20with%20soft%20taupe%20and%20cream%20palette%2C%20abstract%20geometric%20style%2C%20subtle%20gradient%20background%2C%20modern%20flat%20illustration%2C%20professional%20clean%20aesthetic%2C%20gentle%20warm%20tones&width=80&height=80&seq=comment-avatar-04&orientation=squarish',
      content: '行业乱象早该整治了。其实不止这一个网红，很多大主播都存在类似的问题。希望这次事件能成为一个转折点吧。',
      date: '2026-07-07 08:20',
      likes: 7230,
    },
  ],
  2: [
    {
      id: 201,
      author: '瓜田守望者',
      avatar: 'https://readdy.ai/api/search-image?query=Abstract%20circular%20avatar%20in%20muted%20olive%20green%20tones%2C%20simple%20geometric%20design%2C%20soft%20gradient%20background%2C%20modern%20minimalist%20illustration%2C%20friendly%20warm%20aesthetic%2C%20clean%20lines&width=80&height=80&seq=comment-avatar-05&orientation=squarish',
      content: '聊天记录这种事情真的太可怕了，谁的手机里没有点私密对话呢？虽然内容确实很劲爆，但我更担心的是隐私泄露的源头。到底是谁在背后操作这些？',
      date: '2026-07-05 18:45',
      likes: 9870,
    },
    {
      id: 202,
      author: '爆裂吃瓜人',
      avatar: 'https://readdy.ai/api/search-image?query=Simple%20abstract%20circular%20avatar%20with%20warm%20coral%20and%20cream%20palette%2C%20minimalist%20geometric%20design%2C%20soft%20gradient%2C%20modern%20flat%20illustration%20style%2C%20friendly%20inviting%20aesthetic%2C%20clean%20smooth%20shapes&width=80&height=80&seq=comment-avatar-06&orientation=squarish',
      content: '内容我看了，确实很劲爆。但话说回来，私下聊天评论同行这种事情，谁没干过呢？只是我们普通人的聊天记录没人在意而已。',
      date: '2026-07-05 20:30',
      likes: 6540,
    },
  ],
  3: [
    {
      id: 301,
      author: '理性吃瓜人',
      avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20abstract%20avatar%20in%20warm%20beige%20tones%2C%20simple%20geometric%20circular%20design%2C%20soft%20gradient%20background%2C%20modern%20flat%20illustration%20style%2C%20professional%20yet%20friendly%20aesthetic%2C%20clean%20lines%20and%20subtle%20texture&width=80&height=80&seq=comment-avatar-07&orientation=squarish',
      content: '我觉得她说的很对啊，每个人都有多面性。网上展现甜美的一面，私下做真实的自己，这有什么问题吗？难道非要在网上也表现得冷冰冰才叫真实？',
      date: '2026-07-04 15:20',
      likes: 11230,
    },
    {
      id: 302,
      author: '毒舌评论家',
      avatar: 'https://readdy.ai/api/search-image?query=Abstract%20geometric%20avatar%20with%20muted%20sage%20green%20palette%2C%20minimalist%20circular%20design%2C%20soft%20modern%20illustration%20style%2C%20subtle%20gradient%20tones%2C%20clean%20and%20sophisticated%20aesthetic%2C%20professional%20friendly%20feel&width=80&height=80&seq=comment-avatar-08&orientation=squarish',
      content: '人设本来就是表演的一部分。只要不欺骗粉丝感情、不卖假货、不割韭菜，我觉得完全OK。但问题是，很多博主的人设崩塌后会牵连到合作品牌和消费者。',
      date: '2026-07-04 16:45',
      likes: 7890,
    },
  ],
  4: [
    {
      id: 401,
      author: '情感博主小琳',
      avatar: 'https://readdy.ai/api/search-image?query=Simple%20abstract%20circular%20avatar%20in%20warm%20terracotta%20tones%2C%20minimalist%20geometric%20design%2C%20soft%20gradient%20background%2C%20modern%20flat%20illustration%2C%20friendly%20and%20approachable%20aesthetic%2C%20clean%20smooth%20lines&width=80&height=80&seq=comment-avatar-09&orientation=squarish',
      content: '结婚8年了，孩子都两个了，真的走到这一步觉得很可惜。但是感情的事情外人很难判断对错。希望他们能好好处理，不要让孩子受到伤害。',
      date: '2026-07-04 19:15',
      likes: 10230,
    },
  ],
  5: [
    {
      id: 501,
      author: '财经小达人',
      avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20circular%20avatar%20design%20with%20soft%20taupe%20and%20cream%20palette%2C%20abstract%20geometric%20style%2C%20subtle%20gradient%20background%2C%20modern%20flat%20illustration%2C%20professional%20clean%20aesthetic%2C%20gentle%20warm%20tones&width=80&height=80&seq=comment-avatar-10&orientation=squarish',
      content: '年销售额10亿的主播，税务问题肯定是逃不掉的，就看谁先被查而已。这种体量的收入，不做好税务规划就是在走钢丝。现在翻车了谁也别同情。',
      date: '2026-07-03 21:10',
      likes: 13450,
    },
    {
      id: 502,
      author: '法律人张三',
      avatar: 'https://readdy.ai/api/search-image?query=Abstract%20circular%20avatar%20in%20muted%20olive%20green%20tones%2C%20simple%20geometric%20design%2C%20soft%20gradient%20background%2C%20modern%20minimalist%20illustration%2C%20friendly%20warm%20aesthetic%2C%20clean%20lines&width=80&height=80&seq=comment-avatar-11&orientation=squarish',
      content: '从法律角度看，通过设立空壳公司转移收入的行为属于典型的逃税手段。如果金额特别巨大，不仅面临巨额罚款，还可能有刑事责任。这个行业该洗牌了。',
      date: '2026-07-03 22:40',
      likes: 9860,
    },
  ],
};